import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarLightReachCommand } from "./solar-lightreach-cache"
import type { SolarLightReachDto } from "../dto/solar-lightreach.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Refresh status: the server resolves a held submission and reads every
 * application back from LightReach. An approval locks the selections, so the
 * lock's readers refetch with it.
 */
export default function useRefreshSolarLightReachApplication(): UseMutationResult<
  SolarLightReachDto,
  unknown,
  { proposalId: string }
> {
  return useSolarLightReachCommand(
    ({ proposalId }) =>
      solarProposalService.refreshLightReachApplication(proposalId),
    `application`,
  )
}
